/**
 * 从视频URL获取视频时长
 * @param videoUrl 视频URL
 * @returns 视频时长（秒）
 */
export const getVideoDuration = (videoUrl: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');

    // 设置视频源
    video.src = videoUrl;

    // 监听元数据加载完成事件
    video.addEventListener('loadedmetadata', () => {
      // 获取视频时长并转换为秒
      const duration = video.duration;
      resolve(duration);

      // 清理资源
      video.remove();
    });

    // 监听错误事件
    video.addEventListener('error', (error) => {
      console.error('获取视频时长失败:', error);
      reject(new Error('获取视频时长失败'));

      // 清理资源
      video.remove();
    });

    // 加载视频元数据
    video.load();
  });
};
